// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Umrf","label":"styles_label__1eCxn"};